export default "__VITE_ASSET__6956e346__"